/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import SignIn from "pages/authentication/sign-in";

// @mui icons
import Icon from "@mui/material/Icon";
import Dashboard from "pages/dashboard";
import { ROLES } from "components/common/constant";
import DepartmentListing from "pages/department/DepartmentListing";
import StationList from "pages/station/StationList";
import DutyTypeListing from "pages/dutyType/DutyTypeListing";
import UnitListing from "pages/unit/UnitListing";
import CustomerListing from "pages/customer/CustomerListing";
import UserList from "pages/user/UserList";
import ShiftListing from "pages/Shift/ShiftList";
import TechnicianListing from "pages/Technician/TechnicianListing";
import { ForgetPassword } from "pages/Forget-Password/ForgetPassword";
import ProjectListing from "pages/project/ProjectListing";
import ProductListing from "pages/product/ProductListing";
import LHBDataListing from "pages/lhb-data/LHBDataListing";
import DepartmentWorkloadListing from "pages/departmentWorkload/DepartmentWorkloadListing";
import LHBDataDetails from "pages/lhb-data/LHBDataDetails";
import RemarkListing from "pages/remark/RemarkListing";
import SubActivityListing from "pages/activity/SubActivityListing";
import MicroActivityListing from "pages/activity/MicroActivityListing";
import ResetPassword from "pages/reset-password/ResetPassword";
import ContractorListing from "pages/contractor/ContractorList";
import { ACCESS_CONFIG } from "components/common/constant";
import PlantHeadDashboard from "pages/plantHeadDashboard";
import SupervisorDashboard from "pages/supervisorDashboard";
import EmployeeActivityReport from "pages/employeeActivityReport/EmployeeActivityReport";
import EmployeeMasterListing from "pages/employeeMasterReport/EmployeeMasterListing";
import PlanningDashboard from "pages/planningDashboard";
import AdminDashboard from "pages/adminDasbhoard";
import ActiveUserSystemControlReport from "pages/activeUserSystemControlReport/ActiveUserSystemControlReport";
import MasterChangeLogReport from "pages/masterChangeLogReport/MasterChangeLogReport";
import EmployeeEfficiencyReport from "pages/employeeEfficiencyReport/EmployeeEfficiencyReportListing";
import IEDashboard from "pages/ieDashboard";
import ActivityControlReport from "pages/activityControlReport/ActivityControlReport";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "admin-dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/admin-dashboard",
    component: <AdminDashboard />,
    show: true,
    layout: "/admin",
    roles: [ROLES.ADMIN],
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "planning-dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/planning-dashboard",
    component: <PlanningDashboard />,
    show: true,
    layout: "/admin",
    roles: [ROLES.PLANNING_ENGINEER, ROLES.PLANNING_MANAGER],
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "ie-dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/ie-dashboard",
    component: <IEDashboard />,
    show: true,
    layout: "/admin",
    roles: [ROLES.IE_ENGINEER, ROLES.IE_MANAGER],
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "supervisor-dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/supervisor-dashboard",
    component: <SupervisorDashboard />,
    show: true,
    layout: "/admin",
    roles: [ROLES.SUPERVISOR],
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "plant-head-dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/plant-head-dashboard",
    component: <PlantHeadDashboard />,
    show: true,
    layout: "/admin",
    roles: [ROLES.PLANT_HEAD, ROLES.MANAGER],
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "site-business-head-dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/site-business-head-dashboard",
    component: <Dashboard />,
    show: true,
    layout: "/admin",
    roles: [ROLES.SITE_BUSINESS_HEAD],
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/sign-in",
    component: <SignIn />,
    show: false,
    layout: "/auth",
    roles: [],
  },
  {
    type: "collapse",
    show: true,
    name: "LHB Records",
    key: "lhbData",
    route: "/lhbData",
    icon: <Icon fontSize="small">fact_check</Icon>,
    component: <LHBDataListing />,
    layout: "/admin",
    roles: ACCESS_CONFIG.LHB_DATA.VIEW,
  },
  {
    type: "collapse",
    show: false,
    name: "LHB Records",
    key: "lhbDataView",
    route: "/lhbData/view/:id",
    icon: <Icon fontSize="small">fact_check</Icon>,
    component: <LHBDataDetails />,
    layout: "/admin",
    roles: ACCESS_CONFIG.LHB_DATA.VIEW,
  },
  {
    type: "collapse",
    show: false,
    name: "LHB Records",
    key: "lhbDataEdit",
    route: "/lhbData/edit/:id",
    icon: <Icon fontSize="small">fact_check</Icon>,
    component: <LHBDataDetails />,
    layout: "/admin",
    roles: ACCESS_CONFIG.LHB_DATA.VIEW,
  },
  {
    type: "collapse",
    name: "Masters",
    key: "masters",
    icon: <Icon fontSize="small">manage_accounts</Icon>,
    show: true,
    roles: [ROLES.ADMIN],
    collapse: [
      {
        type: "collapse",
        show: true,
        name: "Internal Users",
        key: "user",
        route: "/user",
        icon: <Icon fontSize="small">person</Icon>,
        component: <UserList />,
        layout: "/admin",
        roles: ACCESS_CONFIG.INTERNAL_USERS.VIEW,
      },
      {
        type: "collapse",
        show: true,
        name: "Technicians",
        key: "technicians",
        route: "/technicians",
        icon: <Icon fontSize="small">engineering</Icon>,
        layout: "/admin",
        component: <TechnicianListing />,
        roles: ACCESS_CONFIG.TECHNICIAN_MASTER.VIEW,
      },
      {
        type: "collapse",
        show: true,
        name: "Customers",
        key: "customer",
        route: "/customer",
        icon: <Icon fontSize="small">business</Icon>,
        component: <CustomerListing />,
        layout: "/admin",
        roles: ACCESS_CONFIG.CUSTOMER_MASTER.VIEW,
      },
      {
        type: "collapse",
        show: true,
        name: "Departments",
        key: "department",
        route: "/department",
        icon: <Icon fontSize="small">group</Icon>,
        component: <DepartmentListing />,
        layout: "/admin",
        roles: ACCESS_CONFIG.DEPARTMENT_MASTER.VIEW,
      },
      {
        type: "collapse",
        show: true,
        name: "Stations",
        key: "stations",
        route: "/station",
        icon: <Icon fontSize="small">place</Icon>,
        component: <StationList />,
        layout: "/admin",
        roles: ACCESS_CONFIG.COMMON_MASTER.VIEW,
      },
      // {
      //   type: "collapse",
      //   show: true,
      //   name: "Machines",
      //   key: "machine",
      //   route: "/machine",
      //   icon: <Icon fontSize="small">precision_manufacturing</Icon>,
      //   component: <MachineListing />,
      //   layout: "/admin",
      //   roles: [ROLES.ADMIN],
      // },
      {
        type: "collapse",
        show: true,
        name: "Shifts",
        key: "shifts",
        route: "/shift",
        icon: <Icon fontSize="small">schedule</Icon>,
        component: <ShiftListing />,
        layout: "/admin",
        roles: ACCESS_CONFIG.SHIFT_MASTER.VIEW,
      },
      {
        type: "collapse",
        show: true,
        name: "Units",
        key: "unit",
        route: "/unit",
        icon: <Icon fontSize="small">domain</Icon>,
        component: <UnitListing />,
        layout: "/admin",
        roles: ACCESS_CONFIG.UNIT_MASTER.VIEW,
      },
      {
        type: "collapse",
        show: true,
        name: "Duty Types",
        key: "dutyType",
        route: "/duty-type",
        icon: <Icon fontSize="small">work</Icon>,
        component: <DutyTypeListing />,
        layout: "/admin",
        roles: ACCESS_CONFIG.DUTY_TYPE_MASTER.VIEW,
      },
      {
        type: "collapse",
        show: true,
        name: "Projects",
        key: "project",
        route: "/project",
        icon: <Icon fontSize="small">engineering</Icon>,
        component: <ProjectListing />,
        layout: "/admin",
        roles: ACCESS_CONFIG.PROJECT_MASTER.VIEW,
      },
      {
        type: "collapse",
        show: true,
        name: "Sub Activity",
        key: "subActivity",
        route: "/sub-activity",
        icon: <Icon fontSize="small">task_alt</Icon>,
        component: <SubActivityListing />,
        layout: "/admin",
        roles: ACCESS_CONFIG.SUBACTIVITY_MASTER.VIEW,
      },
      {
        type: "collapse",
        show: true,
        name: "Micro Activity",
        key: "microActivity",
        route: "/micro-activity",
        icon: <Icon fontSize="small">checklist</Icon>,
        component: <MicroActivityListing />,
        layout: "/admin",
        roles: ACCESS_CONFIG.MICROACTIVITY_MASTER.VIEW,
      },
      {
        type: "collapse",
        show: true,
        name: "Products",
        key: "products",
        route: "/product",
        icon: <Icon fontSize="small">inventory_2</Icon>,
        component: <ProductListing />,
        layout: "/admin",
        roles:
          ACCESS_CONFIG.PRODUCT_MASTER?.VIEW ||
          ACCESS_CONFIG.COMMON_MASTER.VIEW,
      },
      {
        type: "collapse",
        show: true,
        name: "Remarks",
        key: "remarks",
        route: "/remark",
        icon: <Icon fontSize="small">description</Icon>,
        component: <RemarkListing />,
        layout: "/admin",
        roles: ACCESS_CONFIG.REMARK_MASTER.VIEW,
      },
      {
        type: "collapse",
        show: true,
        name: "Contractor",
        key: "contractor",
        route: "/contractor",
        icon: <Icon fontSize="small">business</Icon>,
        component: <ContractorListing />,
        layout: "/admin",
        roles: ACCESS_CONFIG.CONTRACTOR_MASTER.VIEW,
      },
    ],
  },
  {
    type: "collapse",
    name: "Reports",
    key: "supervisor-reports",
    icon: <Icon fontSize="small">assessment</Icon>,
    show: true,
    roles: [ROLES.ADMIN, ROLES.SUPERVISOR],
    collapse: [
      {
        type: "collapse",
        show: true,
        name: "Employee Productivity",
        key: "employee-activity",
        route: "/employee-activity",
        icon: <Icon fontSize="small">trending_up</Icon>,
        component: <EmployeeActivityReport />,
        layout: "/admin",
        roles: [ROLES.ADMIN, ROLES.SUPERVISOR],
      },
      {
        type: "collapse",
        show: true,
        name: "Unfilled Timesheet",
        key: "employee-master",
        route: "/employee-master",
        icon: <Icon fontSize="small">schedule</Icon>,
        component: <EmployeeMasterListing />,
        layout: "/admin",
        roles: [ROLES.ADMIN, ROLES.SUPERVISOR],
      },
      {
        type: "collapse",
        show: true,
        name: "Active User Control",
        key: "active-user-system-control-report",
        route: "/active-user-system-control-report",
        icon: <Icon fontSize="small">admin_panel_settings</Icon>,
        component: <ActiveUserSystemControlReport />,
        layout: "/admin",
        roles: [ROLES.ADMIN],
      },
      {
        type: "collapse",
        show: true,
        name: "Master Change Log",
        key: "master-change-log-report",
        route: "/master-change-log-report",
        icon: <Icon fontSize="small">history</Icon>,
        component: <MasterChangeLogReport />,
        layout: "/admin",
        roles: [ROLES.ADMIN],
      },
       {
        type: "collapse",
        show: true,
        name: "Employee Efficiency",
        key: "employee-efficiency-report",
        route: "/employee-efficiency-report",
        icon: <Icon fontSize="small">history</Icon>,
        component: <EmployeeEfficiencyReport />,
        layout: "/admin",
        roles: [ROLES.ADMIN, ROLES.SUPERVISOR],
      },
    ],
  },
  {
    type: "collapse",
    name: "Reports",
    key: "planning-reports",
    icon: <Icon fontSize="small">assessment</Icon>,
    show: true,
    roles: [ROLES.PLANNING_ENGINEER, ROLES.PLANNING_MANAGER],
    collapse: [
      {
        type: "collapse",
        show: true,
        name: "Department Workload",
        key: "department-workload",
        route: "/department-workload",
        icon: <Icon fontSize="small">account_tree</Icon>,
        component: <DepartmentWorkloadListing />,
        layout: "/admin",
        roles: [ROLES.PLANNING_ENGINEER, ROLES.PLANNING_MANAGER],
      },
    ],
  },
  {
    type: "collapse",
    name: "Reports",
    key: "ie-reports",
    icon: <Icon fontSize="small">assessment</Icon>,
    show: true,
    roles: [ROLES.IE_ENGINEER, ROLES.IE_MANAGER],
    collapse: [
      {
        type: "collapse",
        show: true,
        name: "Activity Control Report",
        key: "activity-conrol-report",
        route: "/activity-control-report",
        icon: <Icon fontSize="small">badge</Icon>,
        component: <ActivityControlReport />,
        layout: "/admin",
        roles: [ROLES.IE_ENGINEER, ROLES.IE_MANAGER],
      },
    ],
  },
  {
    type: "collapse",
    name: "Forget Password",
    key: "forget-password",
    route: "/forget-password",
    component: <ForgetPassword />,
    layout: "/auth",
    show: false,
    roles: [],
  },
  {
    type: "collapse",
    name: "Reset Password",
    key: "reset-password",
    route: "/reset-password/:uuid",
    component: <ResetPassword />,
    layout: "/auth",
    show: false,
    roles: [],
  },
];

export default routes;
